import { LIVE_RUNS_MAX_LISTEN_WINDOW_MINUTES } from "@intelligems/ig-types/functions/agentic-codegen/live-runs";

/** Clamp free-text minutes to the server's accepted listen-window range. */
export const clampWindowMinutes = (raw: string): number =>
  Math.min(
    LIVE_RUNS_MAX_LISTEN_WINDOW_MINUTES,
    Math.max(1, Math.floor(Number(raw)) || 1)
  );
